import React from "react";
import { Route, Routes } from "react-router-dom";
import SubPageLayout, { SinglePageLayout } from "./components/layout/PageLayout";
import Home from "./pages/customer/Home";
import Login from "./pages/login/Login";
import FindPassword from "./pages/login/FindPassword";
import ManageServiceUse from "./pages/admin/ManageServiceUse";
import ManageServiceUser from "./pages/customer/ManageServiceUser";
import ManageEvents from "./pages/customer/ManageEvents";
import ManageDevice from "./pages/customer/ManageDevice";
import ManageEquipment from "./pages/customer/ManageEquipment";
import ManageResistDevice from "./pages/customer/ManageResistDevice";
import Statics from "./pages/customer/Statics";
import Alarm from "./pages/webview/Alaram";

export const COMMON_PATH = "/";

function Router() {
  return (
    <Routes>
      {/* 공통 메뉴 */}
      <Route path={`${COMMON_PATH}`} element={<SinglePageLayout pageInfo={<Login />} />} />
      <Route path={`${COMMON_PATH}findPassword`} element={<SinglePageLayout pageInfo={<FindPassword />} />} />

      {/* 관리자용 메뉴 */}
      <Route path={`${COMMON_PATH}manageServiceUse`} element={<SubPageLayout pageInfo={<ManageServiceUse />} />} />

      {/* 고객용 메뉴 */}
      <Route path={`${COMMON_PATH}home`} exact={true} element={<SubPageLayout pageInfo={<Home />} />} />
      <Route path={`${COMMON_PATH}manageServiceUser`} element={<SubPageLayout pageInfo={<ManageServiceUser />} />} />
      <Route path={`${COMMON_PATH}manageEvents`} element={<SubPageLayout pageInfo={<ManageEvents />} />} />
      <Route path={`${COMMON_PATH}manageDevice`} element={<SubPageLayout pageInfo={<ManageDevice />} />} />
      <Route path={`${COMMON_PATH}manageEquipment`} element={<SubPageLayout pageInfo={<ManageEquipment />} />} />
      <Route path={`${COMMON_PATH}manageResistDevice`} element={<SubPageLayout pageInfo={<ManageResistDevice />} />} />
      <Route path={`${COMMON_PATH}statics`} element={<SubPageLayout pageInfo={<Statics />} />} />

      {/* 이벤트 MMS 확인용 WebView */}
      <Route path={`${COMMON_PATH}alarm/:evtId`} element={<SinglePageLayout pageInfo={<Alarm />} />} />
    </Routes>
  );
}

export default Router;
